module.exports = __webpack_public_path__ + "static/KR-9cd067d91cd20d9e100b81ae4f8deeb7.jpg";